import { __extends } from "tslib";
import * as React from 'react';
import { matchPath } from 'react-router';
import { AppServices, Misc } from '@singularsystems/neo-core';
import { NeoReactTypes } from '../Modules/Types';
import { Observer } from 'mobx-react';
var RouteView = /** @class */ (function (_super) {
    __extends(RouteView, _super);
    function RouteView(props) {
        var _this = _super.call(this, props) || this;
        _this.securityService = Misc.Globals.appService.get(AppServices.NeoTypes.Security.SecurityService);
        _this.routeSecurityService = Misc.Globals.appService.get(AppServices.NeoTypes.Routing.RouteSecurityService);
        _this.routingState = Misc.Globals.appService.get(NeoReactTypes.Routing.GlobalRoutingState);
        _this.state = {};
        _this.routingState.currentRouteView = _this;
        return _this;
    }
    Object.defineProperty(RouteView.prototype, "routes", {
        get: function () {
            return this._routes;
        },
        set: function (value) {
            this._routes = value;
            this.routingState.appRouteProvider = value;
        },
        enumerable: false,
        configurable: true
    });
    RouteView.prototype.componentDidMount = function () {
        this.historyBlockDisposer = this.props.history.block(this.beforeLocationChanged.bind(this));
        this.routingState.onRouteChanged();
    };
    RouteView.prototype.componentDidUpdate = function () {
        this.routingState.onRouteChanged();
    };
    RouteView.prototype.componentWillUnmount = function () {
        if (this.historyListenDisposer) {
            this.historyListenDisposer();
        }
        if (this.historyBlockDisposer) {
            this.historyBlockDisposer();
        }
    };
    RouteView.prototype.beforeLocationChanged = function (location, action, isUnload) {
        var _a;
        var currentRoute = this.routingState.currentRoute;
        var match = location ? this.getMatch(location) : undefined;
        var changeProps = {
            isNewView: !currentRoute || !match || match.route !== currentRoute,
            isUnload: isUnload !== null && isUnload !== void 0 ? isUnload : false,
            currentView: (_a = this.routingState.currentView) !== null && _a !== void 0 ? _a : undefined,
            newRoute: match === null || match === void 0 ? void 0 : match.route,
            match: match === null || match === void 0 ? void 0 : match.match
        };
        if (this.routingState.currentView) {
            this.routingState.currentView.beforeRouteChanged(changeProps);
            if (changeProps.leavePrompt === undefined && (changeProps.isNewView || changeProps.isUnload)) {
                changeProps.leavePrompt = this.routingState.currentView.onLeave();
            }
        }
        this.beforeRouteChanged(changeProps);
        if (changeProps.leavePrompt === undefined) {
            return undefined;
        }
        else if (typeof changeProps.leavePrompt === "string") {
            return changeProps.leavePrompt;
        }
        else if (changeProps.leavePrompt === false) {
            return false;
        }
        else {
            this.routingState.leavePromise = changeProps.leavePrompt;
            return "";
        }
    };
    /**
     * Called when the url changes, before the router renders the new view.
     * Return a string to block navigation.
     * @param isNewView True if the view is changing. False if a view parameter value is changing.
     * @param currentView The current view before change.
     */
    RouteView.prototype.beforeRouteChanged = function (props) {
    };
    RouteView.prototype.getMatch = function (location) {
        for (var _i = 0, _a = this._routes.flattenedRoutes; _i < _a.length; _i++) {
            var route = _a[_i];
            var match = matchPath(location.pathname, { path: route.routePath, exact: RouteView.isExact(route) });
            if (match) {
                return { match: match, route: route };
            }
        }
        return null;
    };
    RouteView.isExact = function (route) {
        if (route.exact === undefined) {
            return route.path === "/" || (route.path !== undefined && route.children !== undefined);
        }
        else {
            return route.exact;
        }
    };
    RouteView.prototype.render = function () {
        var _this = this;
        return React.createElement(this.switchComponent, {}, [this.routes.flattenedRoutes.map(function (route) { return (React.createElement(_this.routeComponent, { key: route.key, path: route.routePath, exact: RouteView.isExact(route),
                render: function (props) {
                    _this.routingState.setCurrentRoute(props, route);
                    return React.createElement(Observer, null, function () { return _this.getRouteComponent(route, props.location.pathname + props.location.search); });
                } })); })]);
    };
    RouteView.prototype.getRouteComponent = function (route, path) {
        if (!route.allowAnonymous) {
            if (this.securityService.isAuthenticated) {
                if (!this.isAuthorised(route)) {
                    //Render forbidden
                    return this.getForbiddenComponent(route);
                }
            }
            else {
                //Redirect
                void this.securityService.authentication.beginSignIn(path);
                return this.getSigningInComponent(route);
            }
        }
        return this.getAuthorisedComponent(route, path);
    };
    /**
     * Creates the routes component after authentication and authorisation checks have been done.
     * This can be used to override all routes to display pages like terms and conditions.
     * To redirect to a route, return a react router <Redirect to= /> component.
     */
    RouteView.prototype.getAuthorisedComponent = function (route, path) {
        return React.createElement(route.component, null);
    };
    /**
     * Checks if the user is authorised to access this route.
     * Component from getForbiddenComponent() is returned if not.
     */
    RouteView.prototype.isAuthorised = function (route) {
        return this.routeSecurityService.routeAllowed(route);
    };
    return RouteView;
}(React.Component));
export default RouteView;
